<template>
    <SelectField
        label="In welchem Bereich gründest du?"
        fieldId="division"
        placeholder="Bitte auswählen"
        :options="Object.values(data)"
        option-label="name"
        :select-on-change="selectOnChange"
        :disabled="false"
    />
    <SelectField
        v-if="selected.division"
        label="Mit welcher Rechtsform?"
        fieldId="legalForm"
        placeholder="Bitte auswählen"
        :options="Object.values(selected.division['legalform'])"
        option-label="name"
        :select-on-change="selectOnChange"
        :disabled="false"
    />
    <template v-if="selected.checkBoxes">
        <RadioField
            v-for="checkbox of selected.checkBoxes"
            :key="checkbox['uid']"
            :radio-options="radioOptions"
            :radio-label="checkbox['label']"
            :radio-name="checkbox['uid'].toString()"
            :radio-callback="radioOnChange"
        />
    </template>
</template>

<script>
import SelectField from '@/components/SelectField'
import RadioField from '@/components/RadioField'

export default {
    name: 'Controls',
    components: { RadioField, SelectField },
    props: {
        data: Object,
        controlCallback: Function,
    },
    data() {
        return {
            selected: {
                division: null,
                legalForm: null,
                checkBoxes: null,
                selectedCheckBoxes: {},
            },
            radioOptions: [
                { label: 'Ja', value: true, name: 'yes', default: false },
                { label: 'Nein', value: false, name: 'no', default: true },
            ],
        }
    },
    mounted() {},
    methods: {
        selectOnChange(selection, fieldId) {
            if (fieldId === 'division') {
                this.selected.division = null
                this.selected.legalForm = null
                this.selected.checkBoxes = null
                this.selected.selectedCheckBoxes = {}
            }
            if (fieldId === 'legalForm') {
                this.selected.checkBoxes = null
                this.selected.selectedCheckBoxes = {}
            }
            setTimeout(() => {
                const selectionJson = JSON.parse(selection)
                this.selected[fieldId] = selectionJson
                this.controlCallback(this.selected)
                if (Object.prototype.hasOwnProperty.call(selectionJson, 'checkboxes')) {
                    this.selected.checkBoxes = null
                    this.selected.selectedCheckBoxes = {}
                    this.selected.checkBoxes = selectionJson['checkboxes']
                }
            }, 250)
        },
        radioOnChange(value, id) {
            Object.assign(this.selected.selectedCheckBoxes, new Object({ [id]: value }))
            this.controlCallback(this.selected)
        },
    },
}
</script>

<style scoped></style>
